import React from 'react'; 
import PropTypes from 'prop-types';

import Collapsible from '../../../Basic/Collapsible';
import CheckBox from '../../../Basic/CheckBox';

class BillingTerm extends React.Component {
    render() {
        const p = this.props;
        const lookup = window.osa.lookup.customerDetails.billingTerm;
        const n = p.billingMethod == "0001" ? 0 : 1;
        const title = lookup.items[n].name;
        const content = lookup.items[n].description;
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <Collapsible title={title} content={content} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <CheckBox name={p.name + "_termCheck"} title={lookup.title} disabled={p.disabled} required/>
                    </div>
                </div>
            </div>
        );

    }
}

BillingTerm.propTypes = {
    name: PropTypes.string.isRequired,    
    billingMethod: PropTypes.string,
    disabled: PropTypes.bool,
};

export default BillingTerm;

export function BillingTermValidation(name) {
    return [[name + "_termCheck", p => p[name + "_termCheck"] == 1]];
}